import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LanguageStore } from '../../store/language/language.store';
import { LanguageQuery } from '../../store/language/language.query';
import { TranslocoService } from '@jsverse/transloco';
import { faLanguage } from '@fortawesome/pro-regular-svg-icons';
import { TranslocoLocaleService } from '@jsverse/transloco-locale';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-language-switcher',
	templateUrl: './language-switcher.component.html',
	styleUrls: ['./language-switcher.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class LanguageSwitcherComponent implements OnInit, OnDestroy {
	faLanguage = faLanguage;

	public activeLanguage: string;

	private subscription!: Subscription;

	constructor(
		private languageStore: LanguageStore,
		private languageQuery: LanguageQuery,
		private translocoService: TranslocoService,
		private translocoLocaleService: TranslocoLocaleService
	) {}

	ngOnInit(): void {
		this.initLanguage();
	}

	ngOnDestroy(): void {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	initLanguage(): void {
		this.subscription = this.languageQuery.select().subscribe((res) => {
			const language = ['de', 'en', 'fr', 'es'].includes(res.lang) ? res.lang : 'en';

			if (language === 'de') {
				this.activeLanguage = 'Deutsch';
				this.translocoLocaleService.setLocale('de-DE');
				localStorage.setItem('infoday_locale', 'de-DE');
			} else if (language === 'fr') {
				this.activeLanguage = 'Français';
				this.translocoLocaleService.setLocale('fr-FR');
				localStorage.setItem('infoday_locale', 'fr-FR');
			} else if (language === 'es') {
				this.activeLanguage = 'Español';
				this.translocoLocaleService.setLocale('es-ES');
				localStorage.setItem('infoday_locale', 'es-ES');
			} else {
				this.activeLanguage = 'English';
				this.translocoLocaleService.setLocale('en-US');
				localStorage.setItem('infoday_locale', 'en-US');
			}

			this.translocoService.setActiveLang(language);
			localStorage.setItem('infoday_language', language);
		});
	}

	select(language: string): void {
		this.languageStore.update({ lang: language });
	}
}
